import React from 'react';

import parse from 'html-react-parser';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import CrewContainer from '../../layouts-components__common-cases/crew-container';

import './style.sass';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';

const teamNanoteh1 = {
    crewTitle: 'Вебпрактик',
    crewSubtitle: null,
    crewList: [
        {
            crewItemTitle: 'Ксения Жукова',
            crewItemSubtitle: 'старший менеджер проектов',
        },
        {
            crewItemTitle: 'Юлия Шумская',
            crewItemSubtitle: 'менеджер проектов',
        },
        {
            crewItemTitle: 'Вадим Шапошников',
            crewItemSubtitle: 'руководитель отдела SEO',
        },
        {
            crewItemTitle: 'Виктория Кривко',
            crewItemSubtitle: 'SEO-специалист',
        },
        {
            crewItemTitle: 'Наталья Ковалева',
            crewItemSubtitle: 'SEO-специалист',
        },
    ],
};

const teamNanoteh2 = {
    crewTitle: 'РМ Нанотех',
    crewSubtitle:
        'Выражаем благодарность команде РМ&nbsp;Нанотех за&nbsp;помощь в&nbsp;работе над проектом:',
    crewList: [
        {
            crewItemTitle: 'Роман Антонов',
            crewItemSubtitle: 'начальник отдела маркетинга и связей с общественностью',
        },
        {
            crewItemTitle: 'Евгения Куганова',
            crewItemSubtitle: 'помощник руководителя отдела маркетинга и связей с общественностью',
        },
    ],
};

const Team = () => {
    return (
        <FullWrapper caseName="nanoteh-team">
            <CommonTitle>Команда</CommonTitle>
            <CommonUsualText className="nanoteh-team__info">
                {parse(
                    `Каждому клиенту мы&nbsp;предоставляем отдельную проектную команду. Над&nbsp;поисковым продвижением РМ&nbsp;Нанотех работали 5&nbsp;человек с&nbsp;нашей стороны и&nbsp;2&nbsp;человека со&nbsp;стороны заказчика:`
                )}
            </CommonUsualText>
            <CrewContainer container={teamNanoteh1} />
            <CrewContainer container={teamNanoteh2} />
        </FullWrapper>
    );
};

export default Team;
